import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";

function Sprints() {
    const { t } = useTranslation();

    document.title = `Yoda - ${t('app.sprints')}`;

    return (
        <div className="Sprint">
            <Outlet />
        </div>
    );
}

export default Sprints;
